import React from 'react';

import FullScreenModal from '../Modals/FullScreenModal';
import FullScreenHeader from '../Modals/FullScreenModal/Header';
import { guestListRoute } from '../../helpers/routes';
import { useCustomMessagingRedirect } from '../../hooks/experiment/useCustomMessagingRedirect';
import Loading from '../../Loading';
import Body from './Body';
import styles from './body.scss';

const MessagingHub = () => {
  const { isChecking } = useCustomMessagingRedirect();

  const backHandler = () => {
    window.location.replace(guestListRoute);
  };

  if (isChecking) {
    return (
      <FullScreenModal className={styles.scrollable}>
        <Loading />
      </FullScreenModal>
    );
  }

  return (
    <FullScreenModal className={styles.scrollable}>
      <FullScreenHeader title="Message Guests" onBack={backHandler} className={styles.guestMessageHeader} />
      <Body />
    </FullScreenModal>
  );
};

export default MessagingHub;
